<script setup>
import { ref } from 'vue';
const { options, defaultSelectedIndex, source } = defineProps({
  options: {
    type: Array,
    required: true,
  },
  defaultSelectedIndex: {
    type: Number,
    required: false,
    default: 0,
  },
  source: {
    type: String,
    required: false,
    default: '',
  },
});
const selectedIndex = ref(defaultSelectedIndex);
const emit = defineEmits(['optionSelected']);
const handleClick = (option, index) => {
  selectedIndex.value = index;
  emit('optionSelected', option, source);
};
</script>

<template>
  <button
    class="relative flex h-9 w-full items-center rounded-[5px] border bg-white text-xs"
  >
    <div
      :class="[
        'box-dynamic pointer-events-none z-10 h-full w-1/2 transform rounded-[5px] shadow-md transition-transform duration-100',
        selectedIndex === 1 ? 'translate-x-full' : 'translate-x-0',
      ]"
    ></div>
    <div
      v-for="(option, index) in options"
      :key="option.id"
      @click="handleClick(option, index)"
      :class="[
        'z-5 flex h-full w-1/2 items-center justify-center rounded-[5px] text-center transition-colors duration-100 ease-in-out',
        selectedIndex === index
          ? 'rounded-[5px] bg-sun-400 text-steel-1100 shadow-[0.5px_0.5px_3px_0px_rgba(41,48,61,0.08)]'
          : 'text-steel-900 hover:bg-steel-300',
      ]"
    >
      {{ option.label }}
    </div>
  </button>
</template>

<style scoped>
.box-dynamic {
  position: absolute;
}
</style>
